<template>
  <div class="home-box">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">
          Extension of New Lions Club | Month: {{ month }}
        </h3>
        <v-spacer></v-spacer>
        <go-back-btn></go-back-btn>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form class="pa-5" v-if="lionsClub && !loading">
        <v-row>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">Club Name</div>
            <div class="caption">{{ lionsClub.name }}</div>
          </v-col>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">Type</div>
            <div class="caption">{{ lionsClub.club_type }}</div>
          </v-col>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">Date of extended</div>
            <div class="caption">{{ lionsClub.date_extended }}</div>
          </v-col>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">Chairman</div>
            <div class="caption">{{ lionsClub.chairman.display_name }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">No of members</div>
            <div class="caption">{{ lionsClub.number_of_members }}</div>
          </v-col>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">Guiding Lion 1</div>
            <div class="caption">
              {{ lionsClub.guiding_lion_1.display_name }}
            </div>
          </v-col>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">Guiding Lion 2</div>
            <div class="caption">
              {{ lionsClub.guiding_lion_2.display_name }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">100% MJF Lions Club</div>
            <div class="caption">{{ lionsClub.bonus_100pct_mjf == 1 ? 'Yes' : 'No' }}</div>
          </v-col>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">100% MAF Lions Club</div>
            <div class="caption">{{ lionsClub.bonus_100pct_maf == 1 ? 'Yes' : 'No' }}</div>
          </v-col>
        </v-row>
      </v-form>
    </v-card>   
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import GoBackBtn from "@/components/shared/GoBackBtn";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "MonthlylionsClub",

  components: { GoBackBtn, Alert, Snackbars },

  data: () => ({
    month: "",
    role: localStorage.getItem("role"),
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      pending_comment: "",
    },
    lionsClub: [],
    confirm: false,
  }),

  mounted() {
    this.month = this.$route.params.month;
    this.getLionsClub();
  },

  computed: {
    ...mapGetters({
      defaultExam: "defaultExam",
      defaultSubject: "defaultSubject",
    }),
  },

  methods: {
    getLionsClub() {
      if (this.$route.params.aId !== null) {
        this.loading = true;
        ActivityService.getActivityInfo(
          "extension-of-lion-club",
          this.$route.params.aId
        )
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.lionsClub = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.lionsClub = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
    pending() {},
    submit() {},
    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
    openImage(path) {
      window.open(path, "_blank");
    },
  },
};
</script>
